import { Box, Skeleton } from '@mui/material';
import { ChallengeBarContainer } from './challenge-bar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChallengeBarSkeleton = function ChallengeBarSkeleton(_ref) {
  var isMobile = _ref.isMobile;
  return /*#__PURE__*/_jsxs(ChallengeBarContainer, {
    "data-element": "ChallengeBarContainer",
    "data-component": "ChallengeBarSkeleton",
    "data-source-file": "challenge-bar-skeleton.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: {
          xs: 'column',
          md: 'row'
        },
        width: 1,
        alignItems: {
          xs: 'start',
          md: 'center'
        }
      },
      "data-element": "Box",
      "data-component": "ChallengeBarSkeleton",
      "data-source-file": "challenge-bar-skeleton.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        variant: "rounded",
        width: isMobile ? 140 : 200,
        height: isMobile ? 16 : 40,
        "data-element": "Skeleton",
        "data-component": "ChallengeBarSkeleton",
        "data-source-file": "challenge-bar-skeleton.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        variant: "rounded",
        width: isMobile ? 170 : 270,
        height: isMobile ? 12 : 32,
        sx: {
          mr: 5,
          ml: {
            xs: 0,
            md: 'auto'
          },
          mt: {
            xs: 1,
            md: 0
          }
        },
        "data-element": "Skeleton",
        "data-source-file": "challenge-bar-skeleton.tsx"
      })]
    }), /*#__PURE__*/_jsx(Skeleton, {
      variant: "rounded",
      width: isMobile ? 48 : 140,
      height: isMobile ? 30 : 40,
      "data-element": "Skeleton",
      "data-source-file": "challenge-bar-skeleton.tsx"
    })]
  });
};